import { useNavigate } from 'react-router-dom';
import allblog from '../../../data/allblog';
import BreadCrum from '../basic/BreadCrum';
import { HeadingBanner, HeadingTitle, Paragraph } from '../basic/title';
import { AllCategories, BestSeller } from '../basic/MultiUses';
import size from '../../../data/size';
import { Squarebtn } from '../basic/button';
import {
    fetchAllCategories, fetchOneCategory,
    fetchOneSubCategory
} from "../../../redux/slices/category";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductTab from '../shop/tab/productTab';
import CollectionsShopCard from '../shop/CollectionsShopCard';
import { getProducts } from '../../../redux/slices/product';

export default function DetailsCategoriesPages({ id, categoriesData, wishlist, localCartItems }) {
    const allCategoriesData = categoriesData || [];
    const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [reloadPage, setReloadPage] = useState(false);
    const [allSubProductsData, setAllSubProductsData] = useState([]);
    const [loading, setLoading] = useState(true);

    const { isLoading: categoryIsLoading, error: categoryError, oneCategory, oneSubCategory } = useSelector((state) => state.category);
    const { isLoading: productIsLoading, error: productError, products } = useSelector((state) => state.product);

    useEffect(() => {
        dispatch(getProducts());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchOneCategory(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (reloadPage) {
            window.location.reload();
            setReloadPage(false);
        }
    }, [reloadPage]);

    useEffect(() => {
        if (oneCategory?.all_products) {
            const enriched = oneCategory.all_products.map(prod => {
                const full = products.find(p => p.id === prod.id);
                return full || prod;
            });
            setAllSubProductsData(enriched);
        }
    }, [oneCategory, products]);

    useEffect(() => {
        if (oneSubCategory?.products) {
            const enriched = oneSubCategory.products.map(prod => {
                const full = products.find(p => p.id === prod.id);
                return full || prod;
            });
            setAllSubProductsData(enriched);
        }
    }, [oneSubCategory, products]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    const categoriDetailsRow = (id) => {
        navigate(`/categories/${id}`);
        setReloadPage(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleSubProductsRow = (id) => {
        dispatch(fetchOneSubCategory(id));
    };

    return (
        <>
            <BreadCrum componentName="categories" link="/shop" />
            <div className="container mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                <div className="grid grid-cols-12 gap-6 py-10">

                    {/* Sidebar Categories */}
                    <div className='md:col-span-4 lg:col-span-3 col-span-12'>
                        <div className='pb-10'>
                            <HeadingTitle title="Categories" textAlign='left' />
                            {categoryIsLoading || loading ? (
                                allCategoriesData.map((_, index) => (
                                    <div key={index} className='animate-pulse flex justify-between pt-4'>
                                        <div className='w-[150px] py-2 bg-gray-300 rounded'></div>
                                        <div className='w-10 bg-gray-300 rounded'></div>
                                    </div>
                                ))
                            ) : (
                                <table className='w-full my-2'>
                                    <tbody>
                                        {allCategoriesData.map((row, index) => (
                                            <AllCategories
                                                key={index}
                                                row={row}
                                                onDetailsRow={() => categoriDetailsRow(row.id)}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        <div className='pb-10'>
                            <HeadingTitle title="Best Seller" textAlign='left' />
                            <BestSeller
                              allblog={
                                (() => {
                                  const purchased = allSubProductsData
                                    ?.filter(product => product.purchase_count > 0)
                                    ?.sort((a, b) => b.purchase_count - a.purchase_count)
                                    ?.slice(0, 4);
                            
                                  if(purchased && purchased.length > 0) return purchased;
                                  return allSubProductsData?.slice(0, 2);
                                })()
                              }
                            />
                        </div>

                        <div className=''>
                            <HeadingTitle title="Size" textAlign='left' />
                            <div className='my-4 flex flex-wrap gap-2'>
                                {size.map((row, index) => (
                                    <Squarebtn key={index} title={row.title} bgColor="#036642" textTransform='uppercase' />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className='md:col-span-8 lg:col-span-9 col-span-12'>
                        <div className='px-4 pb-4'>
                            {categoryIsLoading || loading ? (
                                <div className='animate-pulse'>
                                    <div className='w-[200px] h-6 py-2 bg-gray-300 rounded'></div>
                                    <div className='mt-2'>
                                        <div className='w-full h-4 bg-gray-300 rounded'></div>
                                        <div className='w-full h-4 bg-gray-300 rounded my-2'></div>
                                        <div className='w-2/4 h-4 bg-gray-300 rounded'></div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <HeadingBanner color='#072320' title={oneCategory?.name} textAlign='left' />
                                    <Paragraph title={oneCategory?.description} textAlign='left' />
                                </>
                            )}

                            {/* Sub Categories */}
                            <div className='my-6'>
                                <HeadingTitle title="Sub Categories" textAlign='left' />
                            </div>
                            <div className='mb-6'>
                                <div className="grid grid-cols-12 gap-6">
                                    {oneCategory?.children?.map((row, index) => (
                                        <div key={index}
                                            onClick={() => handleSubProductsRow(row?.id)}
                                            className='md:col-span-6 lg:col-span-3 col-span-12 cursor-pointer flex flex-col justify-center p-3 h-full items-center rounded-lg border-[2px] border-[#072320]'>
                                            <div className='flex justify-center items-center bg-[#00A762] rounded-lg p-3'>
                                                <img
                                                    src={BASE_IMAGE_URL + row?.thumbnail_image}
                                                    alt="image"
                                                    className="rounded-lg zoom-image cursor-pointer"
                                                />
                                            </div>
                                            <div className='pt-2'>
                                                <h2 className="text-[#00A762] text-center font-dm text-lg capitalize font-medium">{row?.name}</h2>
                                            </div>
                                            <h1 className='font-dm text-center'>{row?.products_count} Products</h1>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="max-w-screen-lg mx-auto p-4">
                            <ProductTab
                                allproducts={allSubProductsData}
                                productIsLoading={productIsLoading}
                                productError={productError}
                                wishlist={wishlist}
                                localCartItems={localCartItems}
                            />
                        </div>
                    </div>
                </div>

                {/* Most Purchased */}
                <div className="pb-10">
                    <HeadingTitle title="most purchased products" />
                    <div className="mt-4">
                        <CollectionsShopCard allproducts={products} wishlist={wishlist} localCartItems={localCartItems} />
                    </div>
                </div>
            </div>
        </>
    );
}

{/* <div className='my-10'>
    <ErrorPages
        title="Oops! Page Not Found"
        massage="It seems like you've taken a wrong turn. Don't worry, you can head back to our homepage to continue your shopping journey."
        height="350px"
        handleClick={() => { navigate('/') }}
    /></div>; */}